import React from "react";
import { Link, Route, Routes } from "react-router-dom";
import escut from './assets/escut.svg';
import laligaRAW from './laliga.json';
import laligafemRAW from './laligafem.json';
import ligasegundaRAW from './ligasegunda.json';
import ligaacbRAW from './ligaacb.json';
import ligaasobalRAW from './ligaasobal.json';
import RAW_futsal_primer from './futsal/primer.json';
import RAW_futsal_atletic from './futsal/atletic.json';
import okligaRAW from './okliga.json';
import RAW_hoquei_primer from './hoquei/primer.json';
import RAW_hoquei_atletic from './hoquei/atletic.json';
import juvenilARAW from './futbol/juvenil-a.json';
import sub16RAW from './futbol/sub16.json';
import sub15RAW from './futbol/sub15.json';
import sub14RAW from './futbol/sub14.json';
import sub13RAW from './futbol/sub13.json';
import sub12RAW from './futbol/sub12.json';
import sub11ARAW from './futbol/sub11-a.json';
import sub11BRAW from './futbol/sub11-b.json';
import sub10ARAW from './futbol/sub10-a.json';
import sub10BRAW from './futbol/sub10-b.json';
import sub9ARAW from './futbol/sub9-a.json';
import sub9BRAW from './futbol/sub9-b.json';
import sub8ARAW from './futbol/sub8-a.json';
import sub8BRAW from './futbol/sub8-b.json';
import femeninoBRAW from './futbol/femenino-b.json';
import femeninoCRAW from './futbol/femenino-c.json';
import femeninoJuvenilRAW from './futbol/femenino-juvenil.json';
import baloncestoSillaRuedasRAW from './baloncestosilladeruedas.json';
import './FCB.scss';
import bracketACB from './basquet/bracket.json';
import bracketFutSal from './futsal/bracket.json';
import Bracket from "./components/Bracket/BracketV2";
/*

https://api-fcb.pulselive.com/football/standings?compSeasons=792&detail=2&altIds=true - LaLiga Fememina
https://api-fcb.pulselive.com/football/standings?compSeasons=828&detail=2&altIds=true - LaLiga
https://api-fcb.pulselive.com/genericsport/compseasons/30535/standings - Liga ACB
https://api-fcb.pulselive.com/genericsport/compseasons/2557/standings - Liga Segunda Division
https://api-fcb.pulselive.com/genericsport/compseasons/40262/standings - Liga ASOBAL
https://api-fcb.pulselive.com/genericsport/compseasons/20152/standings - Primera División Futsal
https://api-fcb.pulselive.com/genericsport/compseasons/20146/standings - Segunda División Futsal
https://api-fcb.pulselive.com/genericsport/compseasons/80141/standings - OK Liga
https://api-fcb.pulselive.com/genericsport/compseasons/80137/standings - OK Liga Segunda

https://api-fcb.pulselive.com/genericsport/compseasons/15808/standings - División de Honor Grupo 3 2025-26 (Juvenil A)
https://api-fcb.pulselive.com/genericsport/compseasons/15804/standings - División de Honor Catalana Cadete S16 2025-26 (Sub 16)
https://api-fcb.pulselive.com/genericsport/compseasons/15783/standings - División de Honor Catalana Cadete S15 2025-26 (Sub 15)
https://api-fcb.pulselive.com/genericsport/compseasons/15805/standings - División de Honor Catalana Infantil S14 2025-26 (Sub 14)
https://api-fcb.pulselive.com/genericsport/compseasons/15781/standings - Preferente Catalana Alevín S11 G.4 2025-26 (Sub 13)
https://api-fcb.pulselive.com/genericsport/compseasons/15794/standings - Preferente Catalana Infantil S13 G.2 2025-26 (Sub 12)
https://api-fcb.pulselive.com/genericsport/compseasons/15742/standings - Preferente Catalana Alevín S12 G.4 2024-25 (Sub 11A)
https://api-fcb.pulselive.com/genericsport/compseasons/15781/standings - Preferente Catalana Alevín S11 G.4 2025-26 (Sub 11B)
https://api-fcb.pulselive.com/genericsport/compseasons/15790/standings - Preferente Catalana Benjamín S10 G.4 2025-26 (Sub 10A)
https://api-fcb.pulselive.com/genericsport/compseasons/15784/standings - División de Honor Catalana Infantil S13 2025-26 (Sub 10B)
https://api-fcb.pulselive.com/genericsport/compseasons/15782/standings - Preferente Catalana Benjamín S9 G.4 2025-26 (Sub 9A)
https://api-fcb.pulselive.com/genericsport/compseasons/15785/standings - Primera Catalana Benjamín S10 G.12 2025-26 (Sub 9B)
https://api-fcb.pulselive.com/genericsport/compseasons/15786/standings - Primera Catalana Benjamín S9 G.10 2025-26 (Sub 8A)
https://api-fcb.pulselive.com/genericsport/compseasons/15791/standings - Preferente Catalana Alevín S12 G.4 2025-26 (Sub 8B)
https://api-fcb.pulselive.com/genericsport/compseasons/15776/standings - Primera RFEF 2025-26 (Femenino B)
https://api-fcb.pulselive.com/genericsport/compseasons/15818/standings - Tercera RFEF G. V 2025-26 (Femenino C)
https://api-fcb.pulselive.com/genericsport/compseasons/15779/standings - Preferente Catalana Juvenil 2025-26 (Femenino Juvenil)

*/

const FootballIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="currentColor" fill="none" stroke="#141B34" stroke-width="1.5">
    <path d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" />
    <path d="M11.7077 9.34893C11.882 9.21702 12.118 9.21702 12.2923 9.34893L14.545 11.054C14.7193 11.1859 14.7922 11.4197 14.7256 11.6332L13.8652 14.3921C13.7986 14.6055 13.6077 14.75 13.3923 14.75H10.6077C10.3923 14.75 10.2014 14.6055 10.1348 14.3921L9.27437 11.6332C9.20781 11.4197 9.28073 11.1859 9.45499 11.054L11.7077 9.34893Z" />
    <path d="M12 9V5M15 11L19 9.5M14 15L16 18M10 14.5L8 17M9 11.5L5 10.5" />
    <path d="M9 2.5L12.0165 4.62241L15 2.5M2 12.7998L5.19655 10.4388L3.55548 6.72045M19.4703 18.8531L15.6158 18.1555L14.2655 22M20.0298 6.19586L18.8035 9.38978L22 11.7507M8.00992 21.4059L8.05142 17.1665L4.00331 17.21" />
  </svg>
)

const SportIcons = {
  16: FootballIcon,
  2: FootballIcon,
  101: FootballIcon,
  116: FootballIcon,
  3: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="currentColor" fill="none" stroke="#141B34" stroke-width="1.5">
      <path d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" />
      <path d="M2 12C4.28031 14.4289 7.91083 16 12 16C16.0892 16 19.7197 14.4289 22 12" />
      <path d="M12 2V22" />
      <path d="M5.1556 5C4.77388 6.5 5.04007 9 6.56621 11C8.1708 13.1028 9.18243 16 5.36932 19" />
      <path d="M18.8444 5C19.2261 6.5 18.9599 9 17.4338 11C15.8292 13.1028 14.8176 16 18.6307 19" />
    </svg>
  ),
  4: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="currentColor" fill="none" stroke="#141B34" stroke-width="1.5">
      <path d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" />
      <path d="M2 12.9506C8.14512 13.5607 13.5577 8.11477 12.9506 2" />
      <path d="M11.0507 22.0012C10.4406 15.856 15.8866 10.4434 22.0013 11.0505" />
      <path d="M17 20C17 12.8203 11.1797 7 4 7" />
    </svg>
  ),
  8: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="currentColor" fill="none" stroke="#141B34" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
      <path d="M11.8614 19.224L20.8481 3.72126C21.1689 3.16783 20.9654 2.47169 20.3905 2.15561C19.8259 1.8452 19.1047 2.01295 18.754 2.53628L8.61227 17.6689C8.23552 18.2311 7.46084 18.4113 6.85433 18.0778C6.04998 17.6356 6.17032 16.8476 6.44582 16.1473C6.70887 15.4787 6.42574 14.727 5.77639 14.37C4.91469 13.8963 4.03029 14.3288 3.57111 15.0861C2.25235 17.2611 3.35339 20.3548 5.48365 21.526C7.75091 22.7724 10.5962 21.4065 11.8614 19.224Z" />
      <circle cx="18.5" cy="19.5" r="2.5" />
      <path d="M16 7L18 8.5" />
    </svg>
  ),
}

enum HeaderType {
  'GF' = 0,
  'GC' = 1,
  'DG' = 2,
  'Forma' = 3,
  'PF' = 4,
  'PC' = 5,
  'DP' = 6,
}

const { GF, GC, DG, Forma, PF, PC, DP } = HeaderType;

export default class FCB extends React.Component<{}, {
  type: number[];
}> {
  constructor(props: {}) {
    super(props);
    this.state = {
      type: [16],
    }
  }

  setType = (type: number[]) => {
    this.setState({ type });
  }

  render(): React.ReactNode {
    const laliga = {
      name: 'LaLiga',
      key: 'laliga',
      id: laligaRAW.compSeason.id,
      type: 16,
      header: [GF, GC, DG, Forma],
      data: laligaRAW.tables[0].entries.map(
        (t, i) => {
          return {
            name: t.team.name,
            id: t.team.id,
            stats: {
              overall: {
                ...t.overall,
                form: t.form.map(f => {
                  const id = t.team.id;
                  const equipo = f.teams.find(e => e.team.id === id);
                  const rival = f.teams.find(e => e.team.id !== id);
                  if (equipo.score > rival.score) {
                    return 'W';
                  } else if (equipo.score < rival.score) {
                    return 'L';
                  } else {
                    return 'D';
                  }
                })
              },
              away: t.away,
              home: t.home,
            }
          };
        }
      )
    }

    const laligafem = {
      name: 'LaLiga Femenina',
      key: 'laligafem',
      id: laligafemRAW.compSeason.id,
      type: 101,
      header: [GF, GC, DG, Forma],
      data: laligafemRAW.tables[0].entries.map(
        (t, i) => {
          return {
            name: t.team.name,
            id: t.team.id,
            stats: {
              overall: {
                ...t.overall,
                form: t.form.map(f => {
                  const id = t.team.id;
                  const equipo = f.teams.find(e => e.team.id === id);
                  const rival = f.teams.find(e => e.team.id !== id);
                  if (equipo.score > rival.score) {
                    return 'W';
                  } else if (equipo.score < rival.score) {
                    return 'L';
                  } else {
                    return 'D';
                  }
                })
              },
              away: t.away,
              home: t.home,
            }
          };
        }
      )
    }

    function league(raw: any, playsoff?: any) {
      return {
        name: raw.generalData.description,
        key: 'ligasegunda',
        type: raw.generalData.sportCode,
        id: raw.generalData.id,
        header: [GF, GC, DG],
        data: raw.groups[0].teams.map(
          (t, i) => {
            return {
              name: t.teamName,
              id: t.teamId,
              stats: {
                overall: {
                  points: t.points,
                  played: t.played,
                  won: t.wins,
                  drawn: t.draws,
                  lost: t.losses,
                  goalsFor: t.pointsFor,
                  goalsAgainst: t.pointsAgainst,
                  goalsDifference: t.pointsFor - t.pointsAgainst,
                },
              }
            };
          }
        )
      };
    }

    // Liga ACB
    const laligaacb = league(ligaacbRAW);
    const baloncestoSillaRuedas = league(baloncestoSillaRuedasRAW);

    const ligas = {
      ligasegunda: league(ligasegundaRAW),
      juvenilA: league(juvenilARAW),
      sub16: league(sub16RAW),
      sub15: league(sub15RAW),
      sub14: league(sub14RAW),
      sub13: league(sub13RAW),
      sub12: league(sub12RAW),
      sub11A: league(sub11ARAW),
      sub11B: league(sub11BRAW),
      sub10A: league(sub10ARAW),
      sub10B: league(sub10BRAW),
      sub9A: league(sub9ARAW),
      sub9B: league(sub9BRAW),
      sub8A: league(sub8ARAW),
      sub8B: league(sub8BRAW),
      femeninoB: league(femeninoBRAW),
      femeninoC: league(femeninoCRAW),
      femeninoJuvenil: league(femeninoJuvenilRAW),

      futsalPrimer: league(RAW_futsal_primer),
      futsalAtletic: league(RAW_futsal_atletic),
    }

    // ASOBAL
    const ligaasobal = league(ligaasobalRAW);

    // OK Liga
    const hoquei_primer = league(RAW_hoquei_primer);
    const hoquei_atletic = league(RAW_hoquei_atletic);

    const teams = Array.from({ length: 2 ** 4 }, (_, i) => ({
      id: i + 1,
      name: `Team ${i + 1}`,
    }));

    return (
      <>
        <header>
          <nav></nav>
          <div className="escut">
            <span className="mesqueunclub">més que</span>
            <img src={escut} alt="Escut del FC Barcelona" />
            <span className="mesqueunclub">un club</span>
          </div>
          <nav>
            <Link to={'/llegendes'}>Llegendes</Link>
          </nav>
        </header>
        <main id="fcb">
          <Routes>
            <Route path="/" element={
              <>
                
              </>
            } />
            <Route path="/calendari" element={
              <>
                
              </>
            } />
            <Route path="/" element={
              <>
                <nav>
                  <button className={this.state.type.includes(1) || this.state.type.includes(16) ? 'active' : ''} onClick={() => this.setType([1, 16])}>Futbol Masculí</button>
                  <button className={this.state.type.includes(101) || this.state.type.includes(116) ? 'active' : ''} onClick={() => this.setType([101, 116])}>Futbol Femení</button>
                  <button className={this.state.type.includes(3) ? 'active' : ''} onClick={() => this.setType([3])}>Bàsquet</button>
                  <button className={this.state.type.includes(50) ? 'active' : ''} onClick={() => this.setType([50])}>Bàsquet Cadira de Rodes</button>
                  <button className={this.state.type.includes(2) ? 'active' : ''} onClick={() => this.setType([2])}>Futsal</button>
                  <button className={this.state.type.includes(8) ? 'active' : ''} onClick={() => this.setType([8])}>Hoquei</button>
                  <button className={this.state.type.includes(4) ? 'active' : ''} onClick={() => this.setType([4])}>Handbol</button>
                </nav>
                <section className="league">
                  <Bracket data={bracketFutSal} esport={'futsal'} />
                  <Bracket data={bracketACB} esport={'basquet'} />
                </section>
                {
                  [
                    laliga,
                    laligafem,
                    laligaacb,
                    baloncestoSillaRuedas,
                    ligaasobal,
                    hoquei_primer,
                    hoquei_atletic,
                    ...Object.values(ligas),
                  ].filter((league) => this.state.type.includes(league.type)).map((league, i) => (
                    <section key={i} className="league">
                      <h2>{SportIcons[league.type]} {league.name}</h2>
                      <table className={`id${league.id}`}>
                        <tr>
                          <th>#</th>
                          <th>Club</th>
                          <th>P</th>
                          <th>PJ</th>
                          <th>V</th>
                          <th>E</th>
                          <th>D</th>
                          {league.header.map((h, k) => <td key={k}>{HeaderType[h]}</td>)}
                        </tr>
                        {league.data.map((t, j) => {
                          const id = [
                            7746, // ID del Barça en la OK Liga
                            10164, // ID del Barça en la OK Liga Segunda
                            49, // ID del Barça en la Liga
                            1890, // ID del Barça en la Liga Femenina
                            6406, // ID del Barça en la Liga ASOBAL
                            6041, // ID del Barça en la Primera División de Futsal
                            842, // ID del Barça B en Segunda División
                            6216, // ID del Barça en la ACB
                            8470, // Juvenil A
                            11111, // Sub16
                            11112, // Sub15
                            11113, // Sub14
                            11118, // Sub13
                            11115, // Sub12
                            11117, // Sub11A
                            11118, // Sub11B
                            11119, // Sub10A
                            11114, // Sub10B
                            11121, // Sub9A
                            11122, // Sub9B
                            11123, // Sub8A
                            11117, // Sub8B
                            14688,
                            10203,
                            11124,
                          ];
                          return (
                            <tr key={j} className={id.includes(t.id) ? 'highlight' : ''}>
                              <td>{j + 1}</td>
                              <td className="name">{t.name}</td>
                              <td>{t.stats.overall.points}</td>
                              <td>{t.stats.overall.played}</td>
                              <td>{t.stats.overall.won}</td>
                              <td>{t.stats.overall.drawn}</td>
                              <td>{t.stats.overall.lost}</td>
                              {league.header.includes(HeaderType.GF) && <td>{t.stats.overall.goalsFor}</td>}
                              {league.header.includes(HeaderType.GC) && <td>{t.stats.overall.goalsAgainst}</td>}
                              {league.header.includes(HeaderType.DG) && <td>{t.stats.overall.goalsDifference}</td>}
                              {league.header.includes(HeaderType.PF) && <td>{t.stats.overall.pointsFor}</td>}
                              {league.header.includes(HeaderType.PC) && <td>{t.stats.overall.pointsAgainst}</td>}
                              {league.header.includes(HeaderType.DP) && <td>{t.stats.overall.pointsDifference}</td>}
                              {league.header.includes(HeaderType.Forma) && (
                                <td className="form">{t.stats.overall.form.map((result, j) => <span className={result} key={j}>{result}</span>)}</td>
                              )}
                            </tr>
                          )
                        })}
                      </table>
                    </section>
                  ))
                }
              </>
            } />
          </Routes>
        </main>
      </>
    )
  }
}